import React from 'react';
import styled, { css } from 'styled-components';
import hideVisually from 'polished/lib/mixins/hideVisually';
import { inputStyles, placeholderStyles } from '../utils/formStyles';

const Container = styled.div``;

const Input = styled.input<{ $isError?: boolean }>`
    ${inputStyles.base}

    ${({ $isError }): ReturnType<typeof css> | null =>
        $isError ? inputStyles.errorMod : null};

    &::placeholder {
        ${placeholderStyles.base};
    }

    &:focus::placeholder {
        ${placeholderStyles.focusMod};
    }
`;

const Label = styled.label`
    ${hideVisually};
`;

interface FieldTextProps extends React.InputHTMLAttributes<HTMLInputElement> {
    isError?: boolean;
    label?: string;
}

function FieldText({
    ref,
    label,
    id,
    isError,
    ...rest
}: FieldTextProps & { ref?: React.Ref<HTMLInputElement> }): React.ReactElement {
    const generatedId = React.useId();
    const inputId = id !== undefined ? id : generatedId;

    return (
        <Container>
            {label && <Label htmlFor={inputId}>{label}</Label>}
            <Input
                id={inputId}
                ref={ref}
                type="text"
                placeholder={label}
                $isError={isError}
                {...rest}
            />
        </Container>
    );
}

export default FieldText;
